<template>
    <div v-if="language.includes('es')">
        <a href="https://www.funifelt.com/" target="_blank"><img src="@/assets/images/Logo_Funifelt_Color.png" class="logo"></a>
        <h1> Asesores </h1>  
        <div class="advisor-container">
            <div class="advisor-photo">
                <img src="https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2FBrigitte.jpg?alt=media&token=ecfb206c-a5ee-40c3-8e63-b9ac8ff88f2b">
            </div>
            <div class="advisor-name">
                <h2>Jaddy Brigitte Nielsen Nino, Ph.D</h2>
                <h3>COORDINADORA</h3>
                <p>Confiada y fiable en sus habilidades para liderar equipos e inspirar a otros, con habilidades destacadas en dirección y pensamiento crítico. Competente en tecnología, codificación, idiomas y enseñanza. Habla español, inglés y neerlandés.</p>
            </div>
        </div>
        <div class="advisor-container">
            <div class="advisor-photo">
                <img src="https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2FJuan.jpg?alt=media&token=67dc0231-e82f-4cf0-b5a8-1f57caa6a681">
            </div>
            <div class="advisor-name">
                <h2>Juan Camilo Ávila Laverde</h2>
                <h3>DESARROLLADOR</h3>
                <p>Dedicado y fuerte solucionador de problemas, con habilidades destacadas en la gestión del tiempo de desarrollo. Competente en codificación, programación y frameworks, estudia Ingeniería de Software. Habla español e inglés.</p>
            </div>
        </div>
        <div class="advisor-container">
            <div class="advisor-photo">
                <img src="https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2FMari%CC%81a.jpg?alt=media&token=4d894af6-ff06-488a-bb62-33dc91d446ae">
            </div>
            <div class="advisor-name">
                <h2>María José Gómez Valencia</h2>
                <h3>DIRECTORA CREATIVA</h3>
                <p>Comprometida y entusiasta cineasta, con habilidades destacadas en dirección y fotografía. Competente en idiomas y enseñanza, estudia Comunicación Audiovisual y Multimedia. Habla español, inglés y alemán.</p>
            </div>
        </div>
        <div class="advisor-container">
            <div class="advisor-photo">
                <img src="https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2FLaura.jpg?alt=media&token=bf073828-aa56-4f2e-85de-8afd7613e7d0">
            </div>
            <div class="advisor-name">
                <h2>Laura Sofía Hernández Forero</h2>
                <h3>DISEÑADORA</h3>
                <p>Apoya y respeta a sus compañeros de trabajo, con habilidades destacadas en la producción de trabajos de alta calidad. Competente en aplicaciones de Adobe Creative Suite, estudia Comunicación Audiovisual y Multimedia. Habla español e inglés.</p>
            </div>
        </div>
        <div class="advisor-container">
            <div class="advisor-photo">
                <img src="https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2FDavid.jpg?alt=media&token=66b1612f-0adb-452c-8be3-e74523f3da1e">
            </div>
            <div class="advisor-name">
                <h2>David Steven Cañón Reyes</h2>
                <h3>DISEÑADOR</h3>
                <p>Seguro de sí mismo, con un destacado entendimiento de su papel en su equipo. Competente en Davinci Resolve y Blender, estudia Comunicación Audiovisual y Multimedia. Habla español e inglés.</p>
            </div>
        </div>
    </div>
    <div v-else>
        <a href="https://www.funifelt.com/" target="_blank"><img src="@/assets/images/Logo_Funifelt_Color.png" class="logo"></a>
        <h1> Advisors </h1>  
        <div class="advisor-container">
            <div class="advisor-photo">
                <img src="https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2FBrigitte.jpg?alt=media&token=ecfb206c-a5ee-40c3-8e63-b9ac8ff88f2b">
            </div>
            <div class="advisor-name">
                <h2>Jaddy Brigitte Nielsen Nino, Ph.D</h2>
                <h3>COORDINATOR</h3>
                <p>Reliable and confidence in her abilities to lead teams and inspire others, with distinguished directing and critical thinking skills. Competent at technology, coding, languages and teaching. She speaks Spanish, English and Dutch.</p>
            </div>
        </div>
        <div class="advisor-container">
            <div class="advisor-photo">
                <img src="https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2FJuan.jpg?alt=media&token=67dc0231-e82f-4cf0-b5a8-1f57caa6a681">
            </div>
            <div class="advisor-name">
                <h2>Juan Camilo Ávila Laverde</h2>
                <h3>DEVELOPER</h3>
                <p>Dedicated and strong problem solver, with distinguished developing time-managenent skills. Competent at coding, programming and frameworks, studies Software Engineer. He speaks Spanish and English.</p>
            </div>
        </div>
        <div class="advisor-container">
            <div class="advisor-photo">
                <img src="https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2FMari%CC%81a.jpg?alt=media&token=4d894af6-ff06-488a-bb62-33dc91d446ae">
            </div>
            <div class="advisor-name">
                <h2>María José Gómez Valencia</h2>
                <h3>CREATIVE DIRECTOR</h3>
                <p>Committed and enthusiastic filmmaker, with distinguished directing and photography skills. Competent at languages and teaching, studies Audiovisual communication and Multimedia. She speaks Spanish, English and German.</p>
            </div>
        </div>
        <div class="advisor-container">
            <div class="advisor-photo">
                <img src="https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2FLaura.jpg?alt=media&token=bf073828-aa56-4f2e-85de-8afd7613e7d0">
            </div>
            <div class="advisor-name">
                <h2>Laura Sofía Hernández Forero</h2>
                <h3>DESIGNER</h3>
                <p>Supportive and respectful of her coworkers with distinguished, producing high-quality work. Competent at Adobe Creative Suite Apps, studies Audiovisual communication and Multimedia. She speaks Spanish and English.</p>
            </div>
        </div>
        <div class="advisor-container">
            <div class="advisor-photo">
                <img src="https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2FDavid.jpg?alt=media&token=66b1612f-0adb-452c-8be3-e74523f3da1e">
            </div>
            <div class="advisor-name">
                <h2>David Steven Cañón Reyes</h2>
                <h3>DESIGNER</h3>
                <p>Confidence with distinguished understanding his role on his team. Competent at Davinci Resolve and Blender, studies Audiovisual communication and Multimedia. He speaks Spanish and English.</p>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name : 'advisors',
    data () {
        return {
            language: navigator.language
        }
    },
    mounted () {
        if (this.language.includes('es')) {
            document.title = 'Asesores'
        } else {
            document.title = 'Advisors'
        }
    }
}

</script>

<style src="@/assets/css/footer/advisors.css" scoped></style>
